
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import CookieBanner from '../../components/feature/CookieBanner';
import StructuredData from '../../components/feature/StructuredData';
import ScrollToTop from '../../components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import ProcessSection from './components/ProcessSection';
import ZonesSection from './components/ZonesSection';
import TestimonialsSection from './components/TestimonialsSection';
import CtaSection from './components/CtaSection';

const HomePage = () => {
  useEffect(() => {
    document.title = 'Vaciado de Pisos Barcelona - BIOTRAUMA BARCELONA';
    
    const updateMetaTag = (selector: string, attribute: string, content: string) => {
      let meta = document.querySelector(selector);
      if (meta) {
        meta.setAttribute(attribute === 'property' ? 'property' : 'name', selector.includes('property') ? selector.split('="')[1].split('"]')[0] : selector.split('="')[1].split('"]')[0]);
        meta.setAttribute('content', content);
      } else {
        meta = document.createElement('meta');
        if (attribute === 'property') {
          meta.setAttribute('property', selector.split('="')[1].split('"]')[0]);
        } else {
          meta.setAttribute('name', selector.split('="')[1].split('"]')[0]);
        }
        meta.setAttribute('content', content);
        document.head.appendChild(meta);
      }
    };

    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        'Empresa especializada en vaciado de pisos, casas, locales y trasteros en Barcelona. Servicio rápido, discreto y con gestión responsable de residuos. Presupuesto sin compromiso.'
      );
    }

    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', 'Vaciado de Pisos Barcelona - BIOTRAUMA BARCELONA');
    } else {
      const meta = document.createElement('meta');
      meta.setAttribute('property', 'og:title');
      meta.content = 'Vaciado de Pisos Barcelona - BIOTRAUMA BARCELONA';
      document.head.appendChild(meta);
    }

    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute(
        'content',
        'Empresa especializada en vaciado de pisos, casas, locales y trasteros en Barcelona. Servicio rápido, discreto y con gestión responsable de residuos.'
      );
    } else {
      const meta = document.createElement('meta');
      meta.setAttribute('property', 'og:description');
      meta.content = 'Empresa especializada en vaciado de pisos, casas, locales y trasteros en Barcelona. Servicio rápido, discreto y con gestión responsable de residuos.';
      document.head.appendChild(meta);
    }

    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) {
      ogUrl.setAttribute('content', 'https://barcelona.biotrauma.es/');
    } else {
      const meta = document.createElement('meta');
      meta.setAttribute('property', 'og:url');
      meta.content = 'https://barcelona.biotrauma.es/';
      document.head.appendChild(meta);
    }

    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', 'https://barcelona.biotrauma.es/');
    }
  }, []);

  return (
    <>
      <StructuredData type="home" />
      <Navbar />
      <main>
        <HeroSection />
        <ServicesSection />
        <ProcessSection />
        <ZonesSection />
        <TestimonialsSection />
        <CtaSection />
      </main>
      <Footer />
      <CookieBanner />
      <ScrollToTop />
    </>
  );
};

export default HomePage;
